module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av328-e86ef877a1ddad1c166473a741487608.jpg";